import { useQuery } from "@tanstack/react-query";
import { getStatistics, IStatisticsFilters } from "api/statistics-services.request";
import type { IStatisticsResponse } from "shared/models/interfaces/response/statistics.interface";

export default function useStatistics(filters?: IStatisticsFilters) {
  return useQuery<IStatisticsResponse>(
    ["statistics", filters],
    () => getStatistics(filters),
    {
      cacheTime: 5 * 60 * 1000, // 5 minutos
      staleTime: 2 * 60 * 1000, // 2 minutos
    }
  );
} 